import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const MEASUREMENT_ID = "G-W5ED333PK5";

function loadGoogleAnalytics() {
    if (typeof window === "undefined" || !MEASUREMENT_ID) {
        return;
    }

    if (!window.dataLayer) {
        window.dataLayer = [];
    }

    if (!window.gtag) {
        window.gtag = function gtag() {
            window.dataLayer.push(arguments);
        };
    }

    if (!document.querySelector(`script[src*="${MEASUREMENT_ID}"]`)) {
        const script = document.createElement("script");
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
        document.head.appendChild(script);
    }

    if (!window.__gaInitialized) {
        window.gtag("js", new Date());
        window.gtag("config", MEASUREMENT_ID, { send_page_view: false });
        window.__gaInitialized = true;
    }
}

function trackPageView(pathname, search) {
    if (typeof window === "undefined" || !window.gtag) {
        return;
    }

    window.gtag("event", "page_view", {
        page_title: document.title,
        page_path: `${pathname}${search}`,
        page_location: window.location.href,
    });
}

function AnalyticsTracker() {
    const location = useLocation();

    useEffect(() => {
        loadGoogleAnalytics();
    }, []);

    useEffect(() => {
        trackPageView(location.pathname, location.search);
    }, [location.pathname, location.search]);

    return null;
}

export default AnalyticsTracker;
